export enum enumBacStatusOnOpening {
  Allocated=1,
  Open,
  Suspended,
  Closed,
  Limited,
  Dormant,
  'Not Applicable',
  'Semi Dormant',
  Stale,
  Expired
}


export namespace enumBacStatusOnOpening {
  export function values() {
    return Object.keys(enumBacStatusOnOpening).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
